import React from "react";

import {
  CatalogStore,
  FilterStore,
  ConfigurationStore,
  VehicleStore,
} from "stores";

interface IPipeline {
  Component: any;
}

const Pipeline: React.FC<IPipeline> = ({
  Component,
  ...props
}): JSX.Element | null => {
  const { state: catalog } = React.useContext(CatalogStore);
  const { state: vehicles } = React.useContext(VehicleStore);
  const configuration = React.useContext(ConfigurationStore);
  const {
    state: { filter },
    dispatch: dispatchFilter,
  } = React.useContext(FilterStore);

  if (!catalog) return null;

  return (
    <Component
      {...props}
      {...{ catalog, vehicles, configuration, filter, dispatchFilter }}
    />
  );
};

export const PipelineConfiguration: React.FC<IPipeline> = ({
  Component,
  ...props
}): JSX.Element | null => {
  const configuration = React.useContext(ConfigurationStore);
  if (!configuration) return null;

  return <Component {...{ configuration }} />;
};

export default Pipeline;
